import { type ComponentType, type SVGProps } from 'react'
import { PaperAirplaneIcon } from '@heroicons/react/24/solid'

export type ResourceConfig = {
  icon: ComponentType<SVGProps<SVGSVGElement>>
  titleKey: string
  createPath: string
  listPath: string
  createLabelKey: string
  statsKey: string
  statsConfig: Array<{
    labelKey: string
    valueKey: string
  }>
  span?: number
}

export const resourceConfigs: ResourceConfig[] = [
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.containerInstance',
    createPath: '/ecs/instances/create',
    listPath: '/ecs/instances',
    createLabelKey: 'ecs.resources.createContainerInstance',
    statsKey: 'ai.instances',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.running', valueKey: 'running' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.trainingTask',
    createPath: '/train/tasks/create',
    listPath: '/train/tasks',
    createLabelKey: 'ecs.resources.createTrainingTask',
    statsKey: 'ai.trains',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.running', valueKey: 'running' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.inferenceService',
    createPath: '/deploy/deployments/create',
    listPath: '/deploy/deployments',
    createLabelKey: 'ecs.resources.createInferenceService',
    statsKey: 'ai.deployments',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.running', valueKey: 'running' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.dataset',
    createPath: '/ecs/datasets/create',
    listPath: '/ecs/datasets',
    createLabelKey: 'ecs.resources.createDataset',
    statsKey: 'ai.datasets',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.private', valueKey: 'only_me' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.model',
    createPath: '/ecs/models/create',
    listPath: '/ecs/models',
    createLabelKey: 'ecs.resources.createModel',
    statsKey: 'ai.models',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.private', valueKey: 'only_me' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.containerImage',
    createPath: '/ecs/images/create',
    listPath: '/ecs/images',
    createLabelKey: 'ecs.resources.createContainerImage',
    statsKey: 'ai.images',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.private', valueKey: 'only_me' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.storageResource',
    createPath: '', // 存储资源没有创建按钮
    listPath: '/ecs/disks',
    createLabelKey: '',
    statsKey: 'ai.disks',
    statsConfig: [
      { labelKey: 'ecs.resources.diskCount', valueKey: 'total' },
      { labelKey: 'ecs.resources.privateDiskCount', valueKey: 'only_me' },
    ],
    span: 8,
  },
  {
    icon: PaperAirplaneIcon,
    titleKey: 'ecs.resources.imageRepository',
    createPath: '', // 镜像仓库没有创建按钮
    listPath: '/ecs/repositories',
    createLabelKey: '',
    statsKey: 'ai.repositories',
    statsConfig: [
      { labelKey: 'ecs.resources.total', valueKey: 'total' },
      { labelKey: 'ecs.resources.private', valueKey: 'only_me' },
    ],
    span: 8,
  },
]
